import React from 'react'

const WeischerItem = ({wrapperClassName, itemClassName, item})  => (
    <div className={wrapperClassName}>
        <div className={itemClassName + ' weischer-item'} id={item.payload}></div>
        {item.fallbackImage && <div className="weischer-item-fallback-image-container">
            {item.fallbackLink ? item.fallbackLink.destinationType === 'external' ? (
                <div className="weischer-item-overview-hero">
                    <a className='weischer-item-fallback-link' href={item.fallbackLink.url} target={"_blank"}>
                        <img className="weischer-item-fallback-image" src={item.fallbackImage.url}></img>
                    </a>
                </div>
            ) : (
                <div className="weischer-item-overview-hero">
                    <a className='weischer-item-fallback-link' href={item.fallbackLink.url}>
                        <img className="weischer-item-fallback-image" src={item.fallbackImage.url}></img>
                    </a>
                </div>
            ) : (
                <div className="weischer-item-overview-hero">
                    <img className="weischer-item-fallback-image" src={item.fallbackImage.url}></img>
                </div>
            )}
        </div>}
    </div>
)

export default WeischerItem